import keyMirror from "keymirror"
import ActionTypes from "../const/ActionTypes"

export const Screens = keyMirror({
  EXHIBITION: null,
  DRAWING: null,
  REPLAYER: null
})

const initialState = {
  screen: Screens.EXHIBITION
}

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.UI_DRAWING_SCREEN_SHOW:
      return {
        screen: Screens.DRAWING
      }

    case ActionTypes.UI_REPLAY_SCREEN_SHOW:
      return {
        screen: Screens.REPLAYER
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/ui.js